/**
 * The current page's title, as a tiny external store.
 *
 * It exists so the route announcer and the `<title>` element cannot disagree. Reading
 * `document.title` from a parent effect does not work here: routes are `React.lazy`, so the
 * component that knows the title mounts *after* the location has changed, and the parent would
 * announce the page the reader just left.
 */

let title = '';
const listeners = new Set<() => void>();

export function setPageTitle(next: string): void {
  if (next === title) return;

  title = next;
  for (const listener of listeners) listener();
}

export function getPageTitle(): string {
  return title;
}

export function subscribePageTitle(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}
